
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import CurrentAffairsSlides from '../ai/CurrentAffairsSlides';
import AITranslator from '@/components/ai/AITranslator';
import IndianCurrentAffairsReportGenerator from '@/components/ai/IndianCurrentAffairsReportGenerator';
import AdaptiveCurrentAffairs from './AdaptiveCurrentAffairs';
import { useIsMobile } from '@/hooks/use-mobile';

const CurrentAffairsAI: React.FC = () => {
  const { isMobile, isSmallMobile, screenSize } = useIsMobile();
  
  return (
    <Card className="w-full">
      <CardHeader className={`${isSmallMobile ? 'px-2 py-2.5' : isMobile ? 'px-3 py-3' : 'p-4'}`}>
        <CardTitle className={`${isSmallMobile ? 'text-base' : ''}`}>AI Current Affairs Tools</CardTitle>
        <CardDescription className={`${isSmallMobile ? 'text-xs' : ''}`}>
          Generate, translate, personalize and customize current affairs content using AI
        </CardDescription>
      </CardHeader>
      <CardContent className={`${isSmallMobile ? 'p-1.5' : isMobile ? 'p-2' : 'p-4'}`}>
        <Tabs defaultValue="slides" className="space-y-3 sm:space-y-4">
          <TabsList className={`grid w-full ${isSmallMobile ? 'grid-cols-2 gap-1 mb-2' : screenSize === 'sm' ? 'grid-cols-2 gap-1' : 'grid-cols-4'}`}>
            <TabsTrigger 
              value="slides" 
              className={`${isSmallMobile ? 'text-[10px] py-1 px-1' : screenSize === 'sm' ? 'text-xs py-1.5 px-2' : ''}`}
            >
              {isSmallMobile ? 'Slides' : screenSize === 'sm' ? 'AI News' : 'AI News Slides'}
            </TabsTrigger>
            <TabsTrigger 
              value="translator" 
              className={`${isSmallMobile ? 'text-[10px] py-1 px-1' : screenSize === 'sm' ? 'text-xs py-1.5 px-2' : ''}`}
            >
              {isSmallMobile ? 'Trans' : 'Translator'}
            </TabsTrigger>
            <TabsTrigger 
              value="indian-report" 
              className={`${isSmallMobile ? 'text-[10px] py-1 px-1' : screenSize === 'sm' ? 'text-xs py-1.5 px-2' : ''}`}
            >
              {isSmallMobile ? 'Affairs' : screenSize === 'sm' ? 'Indian' : 'Indian Affairs'}
            </TabsTrigger>
            <TabsTrigger 
              value="adaptive" 
              className={`${isSmallMobile ? 'text-[10px] py-1 px-1' : screenSize === 'sm' ? 'text-xs py-1.5 px-2' : ''}`}
            >
              {isSmallMobile ? 'Adapt' : 'Adaptive'}
            </TabsTrigger>
          </TabsList>
          
          <TabsContent value="slides" className={`${isSmallMobile ? 'space-y-2' : 'space-y-3 sm:space-y-4'}`}>
            <CurrentAffairsSlides />
          </TabsContent>
          
          <TabsContent value="translator" className={`${isSmallMobile ? 'space-y-2' : 'space-y-3 sm:space-y-4'}`}>
            <AITranslator />
          </TabsContent>
          
          <TabsContent value="indian-report" className={`${isSmallMobile ? 'space-y-2' : 'space-y-3 sm:space-y-4'}`}>
            <IndianCurrentAffairsReportGenerator />
          </TabsContent>
          
          <TabsContent value="adaptive" className={`${isSmallMobile ? 'space-y-2' : 'space-y-3 sm:space-y-4'}`}>
            <AdaptiveCurrentAffairs />
          </TabsContent>
        </Tabs>
      </CardContent>
    </Card>
  );
};

export default CurrentAffairsAI;
